"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientPaymentsTable = void 0;
const mithril_1 = __importDefault(require("mithril"));
const payment_1 = require("../../../model/payment");
const helpers_1 = require("../../../utils/helpers");
const table_renderers_1 = require("../../../utils/table_renderers");
const alert_box_1 = require("../../../widgets/alert_box");
const table_1 = require("../../../widgets/table");
const contract_print_1 = require("../contract/contract_print");
const invoice_print_1 = require("../invoice/invoice_print");
const moment = require("moment");
function renderStatus(payment) {
    if (payment.paid_at) {
        return (0, helpers_1.tag)(`Payé le ${(0, helpers_1.formatTime)(payment.paid_at, false)}`, "success");
    }
    else {
        if (moment(payment.due_at).isBefore(moment())) {
            return (0, helpers_1.tag)("En retard", "danger");
        }
        else {
            return (0, helpers_1.tag)("A venir", "light");
        }
    }
}
function renderPaymentIcon(payment) {
    if (payment.payment_received) {
        return (0, helpers_1.tag)("Reçu", "success");
    }
    else {
        return (0, helpers_1.tag)("En Attente", "warning");
    }
}
function renderPaymentNotReceived(payment) {
    if (!payment.payment_received) {
        return (0, mithril_1.default)("div", (0, alert_box_1.alertBox)({
            content: [
                (0, helpers_1.iconSpan)("fa-exclamation-triangle"),
                (0, mithril_1.default)("span", " Vos moyens de paiements sont en attente de réception")
            ],
            level: "warning"
        }));
    }
    return undefined;
}
exports.ClientPaymentsTable = (0, table_1.createTable)({
    provider: payment_1.ClientPaymentProvider,
    id: "paymentTable",
    title: "Paiements",
    filters: {
        "due": "En retard",
        "unpaid": "Non payé"
    },
    rowRenderer: (mdl, children) => {
        let firstRow = (0, mithril_1.default)("tr", {
            onclick: (evt) => {
                evt.preventDefault();
                mdl.details_visible = !mdl.details_visible;
            },
            style: "cursor: pointer;"
        }, children);
        if (!mdl.details_visible)
            return firstRow;
        return [
            firstRow,
            (0, mithril_1.default)("tr", (0, mithril_1.default)("td", { colspan: 8, style: "background: #dddddd" }, (0, mithril_1.default)(".content", (0, mithril_1.default)("a.button.is-primary.with-margin", { href: contract_print_1.ContractPrint.link(mdl.contract_id), target: "_blank" }, (0, helpers_1.iconSpan)("fa-eye"), (0, mithril_1.default)("span", "Voir contrat")), (0, mithril_1.default)("a.button.is-info.with-margin", { href: invoice_print_1.InvoicePrint.link(mdl.invoice_id), target: "_blank" }, (0, helpers_1.iconSpan)("fa-file"), (0, mithril_1.default)("span", "Voir facture"))), (0, mithril_1.default)(".content", (0, mithril_1.default)("h4", "Paiements")), renderPaymentNotReceived(mdl), (0, mithril_1.default)("table.table.is-fullwidth", (0, mithril_1.default)("tr", (0, mithril_1.default)("th", "Statut"), (0, mithril_1.default)("th", "Écheance"), (0, mithril_1.default)("th", "Type"), (0, mithril_1.default)("th", "Montant")), mdl.payments.map((payment) => {
                return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", renderStatus(payment)), (0, mithril_1.default)("td", (0, helpers_1.tag)(table_renderers_1.TableRenderers.dateOnly(undefined, payment.due_at), "info")), (0, mithril_1.default)("td", (0, helpers_1.tag)(payment_1.PAYMENT_TYPES[payment.payment_type], "info")), (0, mithril_1.default)("td", (0, helpers_1.tag)(table_renderers_1.TableRenderers.money(undefined, payment.value), "primary")));
            }))))
        ];
    },
    fields: [
        {
            name: "contract_id",
            sortable: false,
            label: "n°"
        }, {
            name: "offer_name",
            label: "Type de forfait",
            sortable: false,
            renderer: table_renderers_1.TableRenderers.tag((mdl) => mdl.offer_name)
        }, {
            name: "payment_mean",
            label: "Moyen de paiement",
            sortable: false,
            renderer: renderPaymentIcon
        }, {
            name: "remaining_minutes",
            sortable: true,
            label: "Crédit restant",
            renderer: table_renderers_1.TableRenderers.time
        }, {
            name: "remaining_cancelable_free_minutes",
            sortable: true,
            label: "Quota d'annulation gratuite restant",
            renderer: table_renderers_1.TableRenderers.time
        }, {
            name: "invoice_ref",
            sortable: false,
            label: "# Facture",
        }, {
            name: "created_at",
            label: "Signé le",
            sortable: true,
            renderer: table_renderers_1.TableRenderers.tag(table_renderers_1.TableRenderers.dateOnly, "info"),
        }, {
            name: "expires_at",
            sortable: true,
            label: "Expiration",
            renderer: (mdl) => {
                if (mdl.active) {
                    if (mdl.expires_at) {
                        return (0, helpers_1.tag)(table_renderers_1.TableRenderers.dateOnly(mdl, mdl.expires_at), "info");
                    }
                    else {
                        return (0, helpers_1.tag)("A définir", "light");
                    }
                }
                else {
                    return (0, helpers_1.tag)("Expiré", "warning");
                }
            }
        },
    ],
    actions: (obj) => {
        let caret = obj.details_visible ? "fa-caret-up" : "fa-caret-down";
        return (0, mithril_1.default)(".button.is-success", (0, helpers_1.iconSpan)(caret), (0, mithril_1.default)("span", "Visualiser"));
    }
});
